import { Button, Space, Row, Col, Form, Checkbox } from 'antd';
import React from 'react';
import {
  DEFAULT_FILTERS,
  DEAL_SUBMISSION_STATUS_OPTIONS,
} from '../../constants';
import {
  ZorbaSelect,
  ZorbaInput,
  ZorbaRangePicker,
} from '../../../../../../components/forms';
import UserAutoComplete from '../../../../../../components/forms/UserAutoComplete';

import './index.scss';
import { YEAR_BUILT_OPTIONS } from './constants';

export default ({
  isLoading,
  form,
  onAdvanceFilterChanged,
  onAdvanceSearchClear,
  powerBuyers,
  onUserAutoCompleteHandler,
  selectedAreas,
  setSelectedAreas,
}) => {
  const applySearch = (appliedSearchCriteria = {}) => {
    if (onAdvanceFilterChanged) {
      onAdvanceFilterChanged({
        ...appliedSearchCriteria,
        areas: selectedAreas,
      });
    }
    setSelectedAreas([]);
  };

  const clearSearch = () => {
    form.resetFields();
    if (onAdvanceSearchClear) {
      onAdvanceSearchClear(DEFAULT_FILTERS);
    }
  };

  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  return (
    <div className="deal-submission-advance-filter">
      <Form
        layout="vertical"
        name="advanceFilter"
        initialValues={DEFAULT_FILTERS}
        onFinish={applySearch}
        autoComplete="off"
        form={form}
      >
        <Row gutter={16}>
          <Col xs={24} xl={24} lg={24} md={24} sm={24}>
            <div className="form-field form-field__group">
              <div className="form-field__item">
                <Form.Item label="Status" name="status">
                  <ZorbaSelect
                    options={DEAL_SUBMISSION_STATUS_OPTIONS}
                    mode="multiple"
                    allowClear
                    placeholder="Select status"
                  />
                </Form.Item>
              </div>
              <div className="form-field__item">
                <Form.Item label="Power Buyer" name="powerBuyers">
                  <ZorbaSelect
                    options={powerBuyers}
                    mode="multiple"
                    allowClear
                    placeholder="Select power buyer"
                    filterOption={filterOption}
                  />
                </Form.Item>
              </div>
              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <div className="form-field__item">
                    <Form.Item
                      label="Min asking price"
                      name="minAskingPrice"
                      rules={[{ type: 'number' }]}
                    >
                      <ZorbaInput minValue="0" type="number" symbol="$" />
                    </Form.Item>
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div className="form-field__item">
                    <Form.Item
                      label="Max asking price"
                      name="maxAskingPrice"
                      rules={[{ type: 'number' }]}
                    >
                      <ZorbaInput minValue="0" type="number" symbol="$" />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <div className="form-field__item">
                    <Form.Item label="Min year built" name="minYearBuilt">
                      <ZorbaSelect
                        options={YEAR_BUILT_OPTIONS}
                        placeholder="Min year built"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div className="form-field__item">
                    <Form.Item label="Max year built" name="maxYearBuilt">
                      <ZorbaSelect
                        options={YEAR_BUILT_OPTIONS}
                        placeholder="Max year built"
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <div className="form-field form-field__group">
                <div className="form-field__item">
                  <ZorbaRangePicker
                    label="Submission date"
                    name="createdAtRange"
                    format="YYYY-MM-DD"
                    allowClear
                    allowEmpty={[true, true]}
                  />
                </div>
              </div>
              <div className="form-field__item">
                <Form.Item label="Wastewater type" name="wastewaterType">
                  <ZorbaSelect
                    options={[
                      {
                        text: 'Septic',
                        value: 'septic',
                      },
                      {
                        text: 'Sewer',
                        value: 'sewer',
                      },
                      {
                        text: 'Not sure',
                        value: '',
                      },
                    ]}
                  />
                </Form.Item>
              </div>
              <div className="form-field__item">
                <Form.Item label="Seller name" name="sellerName">
                  <UserAutoComplete
                    onAutoCompleteSelect={onUserAutoCompleteHandler}
                  />
                </Form.Item>
              </div>
              <div className="form-field__item">
                <Form.Item
                  name="onlyInboxMissingInfo"
                  valuePropName="checked"
                >
                  <Checkbox>Inbox missing info only</Checkbox>
                </Form.Item>
              </div>
            </div>
          </Col>
          <Col xs={24} xl={24} lg={24} md={24} sm={24}>
            <Space
              align="end"
              style={{ height: '100%', marginTop: '12px' }}
              className="btn-group-filter"
            >
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                disabled={isLoading}
              >
                Search
              </Button>
              <Button
                type="default"
                size="large"
                onClick={clearSearch}
                disabled={isLoading}
              >
                Clear all filters
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
